import { PaginationResults, Talent } from "src/types";
import { TalentPaginatedParams } from "./type";
import { get } from "../utils";

export async function getTalentsPaginated(
  queryParams: TalentPaginatedParams
): Promise<PaginationResults<Talent>> {
  const response = (await get({ path: "freelancer/paginated", queryParams })).body;
  // Patch: later we need to update in the back the "talents" field to "data"
  return { ...response, data: response.talents };
}

export async function getTalent(id: number): Promise<Talent> {
  const response = (await get({ path: "freelancer/profile/id", suffix: `${id}` })).body;
  return response.data;
}
